import React from 'react';
import { ThemeContainer, ThemeProvider, useTheme } from '@dropbox/dig-foundations';
import { useIsFullscreen } from 'js/file_viewer/api/ui';
export const FileViewerThemeProvider = ({ children }) => {
    const isFullscreen = useIsFullscreen();
    const isDarkMode = useTheme().mode === 'dark';
    const mode = isFullscreen || isDarkMode ? 'dark' : 'bright';
    return (React.createElement(ThemeProvider, { mode: mode },
        React.createElement(ThemeContainer, null, children)));
};
FileViewerThemeProvider.displayName = "FileViewerThemeProvider"
//# sourceMappingURL=theme_provider.preenvesnextjs.map
